import { RequestInfoFormValues, StatusFormValues } from '../Forms';
import { NullableString } from '../../utils/types';
import { ISelectOption, ISelectOptions } from 'react-ocean-forms-bootstrap';

export enum KomponentenTypEnum {
  Dimension = 'DIMENSION',
  Stoff = 'STOFF',
  Nichtstofflich = 'NICHTSTOFFLICH',
  Einheit = 'EINHEIT',
  Probenvorbehandlung = 'PROBENVORBEHANDLUNG',
  Methode = 'METHODE',
  SonstigesKriterium = 'SONSTIGES_KRITERIUM',
  Matrix = 'MATRIX'
}


export interface EinheitForm {
  kind: KomponentenTypEnum.Einheit;
  symbol: NullableString;
  dimension: ISelectOption | undefined;
  iso_code: NullableString;
}

export interface DimensionForm {
  kind: KomponentenTypEnum.Dimension;
  symbol: NullableString;
}

export interface MatrixForm {
  kind: KomponentenTypEnum.Matrix;
  annotations?: NullableString;
}

export interface MethodForm {
  kind: KomponentenTypEnum.Methode;
  annotations?: NullableString;
  titel: NullableString;
  valid_from: NullableString;
}

export interface MaterialForm {
  kind: KomponentenTypEnum.Stoff;
  casnumber: NullableString;
  eunumber: NullableString;
  sumformula: NullableString;
  alternativnamen: ISelectOptions;
  annotations?: NullableString;
}

export interface NonmaterialForm {
  kind: KomponentenTypEnum.Nichtstofflich;
  annotations?: NullableString;
}

export interface ProbenvorbehandlungForm {
  kind: KomponentenTypEnum.Probenvorbehandlung;
  annotations?: NullableString;
}

export interface SonstigesForm {
  kind: KomponentenTypEnum.SonstigesKriterium;
  annotations?: NullableString;
}


export interface BaseComponentFormValues  {
  component_name: ISelectOption;
  code: NullableString;
  name: string;
  status: StatusFormValues;
  anforderung: RequestInfoFormValues;
}

// use of partial types , ISelectOption noch anpassen
// https://www.typescriptlang.org/docs/handbook/advanced-types.html#discriminated-unions
export type ComponentFormValues = BaseComponentFormValues & 
( EinheitForm | DimensionForm | MatrixForm | MethodForm | MaterialForm | NonmaterialForm | SonstigesForm | ProbenvorbehandlungForm );

export type OptionalComponentFormValues = ComponentFormValues | undefined;

